/**
 * Inside-сцены — полноразмерные 3D-сцены, в которые можно перейти из
 * основной по клику «Open 3D» в чате (в отличие от PoiArtifact — overlay
 * поверх текущей сцены).
 *
 * Структурно — обычные `SceneConfig`, проходят через стандартный пайплайн
 * `SceneCanvas` (прелоадер, reveal, FPS, dispose, transition-gate, HUD).
 * splatRegistry.ts делает фолбэк сюда, поэтому `isSplatScene(insideId)`
 * и `getSplatSceneConfig(insideId)` возвращают валидные значения.
 *
 * Навигация: пушится в `$sceneStack` с `transient: true` — URL остаётся
 * на родительской сцене (`/kaaba`), кнопка «назад» в App.tsx вытаскивает
 * через `goBack()`.
 */
import type { SceneConfig } from '../sceneConfig';
import { kaabaInsideSceneConfig } from './kaabaInside';

const insideSceneConfigs: Record<string, SceneConfig> = {
  // Backend может прислать любой из двух id — мапим оба на одну сцену.
  'kaaba-inside': kaabaInsideSceneConfig,
  'kaaba-inside-scene': kaabaInsideSceneConfig,
};

/**
 * Какую основную сцену открывать при выходе (back-кнопка) из inside-сцены.
 * Ключ — id inside-сцены, значение — id родителя.
 */
export const INSIDE_SCENE_PARENT: Record<string, string> = {
  'kaaba-inside': 'kaaba',
  'kaaba-inside-scene': 'kaaba',
};

export const getInsideSceneConfig = (id: string): SceneConfig | undefined =>
  insideSceneConfigs[id];

export const isInsideScene = (id: string): boolean => id in insideSceneConfigs;

export const getInsideSceneIds = (): string[] => Object.keys(insideSceneConfigs);
